<template>
  <v-container
    fluid
    class="grey lighten-4 fill-height"
  >
    <v-layout align-top>
      <v-flex
        xs12
        sm12
        md12
        lg8
        ma-5
      >
        <!--       <v-subheader>Crawlers</v-subheader>
 -->
        <v-card
          max-width="90%"
          class="mx-auto"
        >
          <v-list
            two-line
            subheader
          >
            <v-subheader>Crawlers</v-subheader>

            <v-list-item
              @click="noop()"
              v-for="(item, ix) in crawlers"
              :key="ix"
            >
              <v-list-item-action class="mx-0 mt-3">
                <v-list-item-icon class="mx-1">
                  <!-- <v-icon :color="item.link ? 'deep-blue accent-4' : 'grey'">mdi-wrench</v-icon> -->
                  <v-switch
                    v-model="item.active"
                  />
                </v-list-item-icon>
              </v-list-item-action>


              <v-list-item-avatar class="px-0 mx-0 mt-1">
                <v-img src="https://cdn.dribbble.com/users/722835/avatars/normal/2aa863d0913f94812e4c74867836e3af.jpg?1573346454" />
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="item.name" />
                <v-list-item-subtitle v-text="item.crawler" />
              </v-list-item-content>
              <!-- 
        <v-list-item-action>        
          <v-list-item-icon>
            <v-icon :color="item.link ? 'deep-blue accent-4' : 'grey'">mdi-wrench</v-icon>
          <v-switch v-model="item.active"
          ></v-switch>
          </v-list-item-icon>
        </v-list-item-action> -->

              <!--         <v-list-item-action>        
          <v-list-item-icon>
            <v-icon @click="noop()" :color="item.link ? 'deep-blue accent-4' : 'grey'">delete</v-icon>
          </v-list-item-icon>
        </v-list-item-action> 
 -->
              <!--         <v-list-item-action>
          <v-list-item-icon>
            <v-icon @click="noop()" :color="item.link ? 'deep-blue accent-4' : 'grey'">mdi-run</v-icon>
          </v-list-item-icon>
        </v-list-item-action> -->

<!--
              <v-list-item-action>        
                <v-list-item-icon>
                  <v-icon
                    @click="noop()"
                    :color="item.link ? 'deep-blue accent-4' : 'grey'"
                  >
                    mdi-information
                  </v-icon>
                </v-list-item-icon>
              </v-list-item-action>
 -->

              <v-list-item-action>
                <v-list-item-icon>
                  <v-icon
                    @click="noop()"
                    :color="item.link ? 'deep-blue accent-4' : 'grey'"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </v-list-item-icon>
              </v-list-item-action>



            </v-list-item>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
export default {
  name: 'Crawlers',
  components: {
  },
  computed: {
  },    
  data: () => ({
    crawlers: [
      {name: 'HackerNews', link: 'https://news.ycombinator.com', active: true, crawler: 'Feeds'},
      {name: 'Lobste.rs', link: 'https://lobste.rs', active: true, crawler: 'Feeds'},
      {name: 'kvoss/mindsink-data', link: 'https://lobste.rs', active: true, crawler: 'Github'},
      {name: 'shuaibiyy/awesome-terraform', link: 'https://lobste.rs', active: false, crawler: 'Github'},
      {name: '/r/informationretrieval', link: 'https://lobste.rs', active: false, crawler: 'Reddit'},
      {name: 'datasciencectrl', link: 'https://lobste.rs', active: true, crawler: 'Twitter'},
      {name: '"GOOG stock plunges"', link: 'https://lobste.rs', active: false, crawler: 'DuckDuckGo'},
    ]
  }),
  methods : {
    noop: () => {
      return;
    }
  }
};
</script>


<style scoped>
</style>
